import Image from 'next/image';
import { breakpoints } from './constants';
import Slider from '@/components/slider/Slider';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import { ImageSliderProps } from './types';

const ImageSlider = ({
  conditionImages,
  condition,
  sliderPreset,
}: ImageSliderProps) => {
  if (sliderPreset) {
    return (
      <div>
        {conditionImages && conditionImages.length > 1 ? (
          <Slider breakpoints={breakpoints} hideArrow paginationDots lazyLoad>
            {conditionImages?.map((image, i) => (
              <div
                key={`image_${i}_${condition}`}
                className="h-full rounded-lg bg-[#EFF2F9]"
              >
                <Image
                  src={getEdgeUrl(image)}
                  alt={condition}
                  width={500}
                  height={450}
                  className="swiper-lazy h-full w-full object-fill"
                  loading="lazy"
                  quality={100}
                />
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="w-full pb-6">
            <div className="w-full rounded-lg bg-[#EFF2F9]">
              <Image
                src={getEdgeUrl(conditionImages[0])}
                alt={condition}
                width={500}
                height={450}
                className="mx-auto h-full w-[85vw] object-contain xs:w-[77vw] md:w-[38vw] xl:w-[23vw] 2xl:w-[31vw]"
                quality={100}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default ImageSlider;
